import { Button } from "@mui/material";

import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

import { Stack } from "@mui/material";
import { Dispatch, SetStateAction, useState, useEffect } from "react";

export interface DivisionChukkers {
  [key: string]: number;
}

function GameDivisionRequest({
  gameDivisionDetails,
  totalDivisionChukkers,
  chukkerRequested,
  setDivisionChukkers,
  divisionChukkers,
}: {
  gameDivisionDetails: string[];
  totalDivisionChukkers: number;
  chukkerRequested: number;
  setDivisionChukkers: Dispatch<SetStateAction<DivisionChukkers>>;
  divisionChukkers: DivisionChukkers;
}) {
  const [selectedDivisions, setSelectedDivisions] = useState<string[]>([]);

  useEffect(() => {
    // Initialize selectedDivisions based on existing divisionChukkers
    if (Object.keys(divisionChukkers).length > 0) {
      setSelectedDivisions(Object.keys(divisionChukkers));
    } else {
      setSelectedDivisions([""]);
    }
  }, [divisionChukkers]);

  const handleDivisionChange = (division: string, index: number) => {
    const newSelectedDivisions = [...selectedDivisions];
    newSelectedDivisions[index] = division;
    setSelectedDivisions(newSelectedDivisions);
  };

  const handleDivisionChukkersChange = (division: string, chukkers: number) => {
    console.log(division, chukkers);
    setDivisionChukkers((prev) => ({
      ...prev,
      [division]: chukkers,
    }));
  };

  const addDivisionSelection = () => {
    setSelectedDivisions([...selectedDivisions, ""]);
  };

  const removeDivisionSelection = (index: number) => {
    const newSelectedDivisions = selectedDivisions.filter(
      (_, i) => i !== index
    );
    setSelectedDivisions(newSelectedDivisions);
    const newDivisionChukkers = { ...divisionChukkers };
    delete newDivisionChukkers[selectedDivisions[index]];
    setDivisionChukkers(newDivisionChukkers);
  };

  if (gameDivisionDetails && gameDivisionDetails.length > 0) {
    return (
      <Stack spacing={2}>
        <Stack spacing={2}>
          {selectedDivisions.map((division, index) => (
            <Box
              key={index}
              sx={{ display: "flex", gap: 2, alignItems: "center" }}
            >
              <FormControl fullWidth>
                <InputLabel>Select Division</InputLabel>
                <Select
                  value={division}
                  label="Select Division"
                  onChange={(e) => handleDivisionChange(e.target.value, index)}
                >
                  {gameDivisionDetails.map((div) => (
                    <MenuItem
                      key={div}
                      value={div}
                      disabled={
                        selectedDivisions.includes(div) &&
                        selectedDivisions[index] !== div
                      }
                    >
                      {div}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ minWidth: 120 }}>
                <InputLabel>Chukkers</InputLabel>
                <Select
                  value={divisionChukkers[division] || 0}
                  label="Chukkers"
                  onChange={(e) =>
                    handleDivisionChukkersChange(
                      division,
                      Number(e.target.value)
                    )
                  }
                >
                  {[
                    ...Array(
                      chukkerRequested -
                        totalDivisionChukkers +
                        (divisionChukkers[division] || 0) +
                        1
                    ),
                  ].map((_, i) => (
                    <MenuItem key={i} value={i}>
                      {i}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button
                color="error"
                onClick={() => removeDivisionSelection(index)}
                disabled={selectedDivisions.length === 1}
              >
                Remove
              </Button>
            </Box>
          ))}

          {selectedDivisions.length < gameDivisionDetails.length && (
            <Button
              variant="outlined"
              onClick={addDivisionSelection}
              disabled={totalDivisionChukkers >= chukkerRequested}
            >
              Add Division
            </Button>
          )}

          {totalDivisionChukkers !== chukkerRequested && (
            <Typography color="error">
              Total chukkers ({totalDivisionChukkers}) must equal requested
              chukkers ({chukkerRequested})
            </Typography>
          )}
        </Stack>
      </Stack>
    );
  }
  return null;
}

export default GameDivisionRequest;
